import { phoneSize } from '@/assets/styles/mediaSize';
import { flexPos } from '@/assets/styles/mixin';
import { FC, ReactNode } from 'react';
import { styled } from 'styled-components';

const MobMediaPreviewWrap = styled.div<{ $show: boolean }>`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  /* background-color: #008c8c; */
  @media (max-width: ${phoneSize}) {
    background-color: #000;
  }
  background-color: transparent;

  z-index: 999;
  ${flexPos('center')}

  display: ${({ $show }) => ($show ? 'flex' : 'none')};

  .img-content {
    width: 100%;
  }

  .icon-download {
    width: 64rem;
    position: absolute;
    right: 32rem;
    bottom: 20rem;
    z-index: 9;
  }

  .icon-close-media {
    width: 64rem;
    position: absolute;
    left: 32rem;
    bottom: 20rem;
    z-index: 9999;
  }
`;

const MobMediaPreview: FC<{ show: boolean; children: ReactNode }> = ({ show, children }) => {
  return <MobMediaPreviewWrap $show={show}>{children}</MobMediaPreviewWrap>;
};

export default MobMediaPreview;
